/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerDownloadQueryResponse, ComparisonsControllerDownloadPathParams, ComparisonsControllerDownload400, ComparisonsControllerDownload401, ComparisonsControllerDownload403, ComparisonsControllerDownload404 } from "../../models/comparisonsController/ComparisonsControllerDownload";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { comparisonsControllerDownload } from "../../clients/comparisonsService/comparisonsControllerDownload";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const comparisonsControllerDownloadQueryKey = (id: ComparisonsControllerDownloadPathParams["id"]) => [{
  url: '/api/v1/comparisons/:id/download',
  params: {
    id: id
  }
}] as const;
export type ComparisonsControllerDownloadQueryKey = ReturnType<typeof comparisonsControllerDownloadQueryKey>;
export function comparisonsControllerDownloadQueryOptions(id: ComparisonsControllerDownloadPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = comparisonsControllerDownloadQueryKey(id);
  return queryOptions<ComparisonsControllerDownloadQueryResponse, ResponseErrorConfig<ComparisonsControllerDownload400 | ComparisonsControllerDownload401 | ComparisonsControllerDownload403 | ComparisonsControllerDownload404>, ComparisonsControllerDownloadQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return comparisonsControllerDownload(id, config);
    }
  });
}

/**
 * @summary Download comparison PDF (streams bytes or redirects to S3 for legacy comparisons)
 * {@link /api/v1/comparisons/:id/download}
 */
export function useComparisonsControllerDownload<TData = ComparisonsControllerDownloadQueryResponse, TQueryData = ComparisonsControllerDownloadQueryResponse, TQueryKey extends QueryKey = ComparisonsControllerDownloadQueryKey>(id: ComparisonsControllerDownloadPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<ComparisonsControllerDownloadQueryResponse, ResponseErrorConfig<ComparisonsControllerDownload400 | ComparisonsControllerDownload401 | ComparisonsControllerDownload403 | ComparisonsControllerDownload404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? comparisonsControllerDownloadQueryKey(id);
  const query = useQuery({
    ...comparisonsControllerDownloadQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ComparisonsControllerDownload400 | ComparisonsControllerDownload401 | ComparisonsControllerDownload403 | ComparisonsControllerDownload404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}